var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.chartComponent,{ref:"chart",tag:"component",staticClass:"va-chart",attrs:{"options":_vm.options,"chart-data":_vm.data}})
}
var staticRenderFns = []

export { render, staticRenderFns }